<template>
    <router-view :key="$route.fullPath" />
</template>
<script>

</script>
<style>
iframe{ width:100%; height: 100%; border: 0; background-color: #ffffff; }
</style>
